'use client';

import React, { useRef, useState } from 'react';
import { useGSAP } from '@gsap/react';
import { gsap } from 'gsap';

const SmoothCursorFollower = ({ isOverCarousel }) => {
    const cursorRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useGSAP(() => {
        if (!cursorRef.current) return;

        const mm = gsap.matchMedia();
        mm.add('(prefers-reduced-motion: no-preference)', () => {
            gsap.set(cursorRef.current, { xPercent: -50, yPercent: -50 });

            const xTo = gsap.quickTo(cursorRef.current, 'x', { duration: 0.5, ease: 'power2.out' });
            const yTo = gsap.quickTo(cursorRef.current, 'y', { duration: 0.5, ease: 'power2.out' });

            // Snap to the pointer on the very first move (so it doesn't fly in
            // from the corner), then ease afterwards.
            let initialized = false;
            const updatePosition = (e) => {
                if (!initialized) {
                    gsap.set(cursorRef.current, { x: e.clientX, y: e.clientY });
                    initialized = true;
                } else {
                    xTo(e.clientX);
                    yTo(e.clientY);
                }
                // Reveal on movement instead of document 'mouseenter', which never
                // fires when the pointer is already inside the window on load.
                setIsVisible(true);
            };
            const hide = () => setIsVisible(false);

            window.addEventListener('mousemove', updatePosition);
            document.documentElement.addEventListener('mouseleave', hide);
            window.addEventListener('blur', hide);

            return () => {
                window.removeEventListener('mousemove', updatePosition);
                document.documentElement.removeEventListener('mouseleave', hide);
                window.removeEventListener('blur', hide);
            };
        });
    }, { scope: cursorRef });

    return (
        <div
            className="cursor-follower"
            ref={cursorRef}
            style={{
                position: 'fixed',
                width: isOverCarousel ? '60px' : '30px',
                height: '30px',
                borderRadius: '15px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid white',
                boxShadow: '0 0 0 1px black',
                pointerEvents: 'none',
                zIndex: 9999,
                opacity: isVisible ? 1 : 0,
                transition: 'width 0.3s ease, opacity 0.2s ease',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 5px',
                boxSizing: 'border-box',
            }}
        >
            {isOverCarousel && (
                <>
                    <span className="cursor-arrow-left" style={{ fontSize: '14px', color: 'gray', textShadow: '0 0 1px black' }}>←</span>
                    <span className="cursor-arrow-right" style={{ fontSize: '14px', color: 'gray', textShadow: '0 0 1px black' }}>→</span>
                </>
            )}
        </div>
    );
};

export default SmoothCursorFollower;
